export default __webpack_public_path__ + "static/media/2028.c7d218b6.png";